import { join } from 'node:path';
import { WIX_LOCK_FILENAME } from '@wix/cli-core-definitions';
import { outputFile } from '@wix/cli-fs';
import { CliError, CliErrorCode } from '@wix/cli-error';

export async function saveWixLock(
  projectFolder: string,
  lockFileContent: string
) {
  const wixLockPath = join(projectFolder, WIX_LOCK_FILENAME);
  try {
    await outputFile(wixLockPath, lockFileContent);
  } catch (e) {
    throw new CliError({
      code: CliErrorCode.FailedToWriteWixLock(),
      cause: e,
    });
  }
}
